module.exports = __webpack_public_path__ + "img/DIFF_PHOTO_VIDEO_ACTIVE.051fbfbf.svg";